import { cn } from '../../utils'

export const getBaseClasses = () => {
    return 'border-inactive/20 justify-start inline-flex'
}

export const getMenuClassNames = (classNames?: string) => {
    const menuClasses =
        'w-dropdown bg-background-base rounded-2xl shadow border border-inactive/20 flex-col'
    return cn(getBaseClasses(), menuClasses, classNames)
}

export const getBaseItemContainerClassNames = (classNames?: string) => {
    const itemClasses =
        'w-dropdown-item self-stretch flex items-center justify-center p-0 focus:outline-none first:border-none first:rounded-t-2xl last:rounded-b-2xl align-center cursor-pointer border-t w-full h-full'

    return cn(itemClasses, getBaseClasses(), classNames)
}

export const getBaseItemClassNames = (classNames?: string) => {
    return cn(
        'justify-start items-center gap-2.5 flex w-full h-full',
        classNames
    )
}
